const lang = ({
    state: {
        trans: {},
        langs: {}
    },
    mutations: {
        SET_TRANS: (state, data) => {
            state.trans = data;
        },
        SET_LANGS: (state, data) => {
            state.langs = data;
        },
        initialiseStore(state) {
            if (localStorage.getItem('trans')) {
                state.trans        = JSON.parse(localStorage.getItem("trans"));
                state.langs        = JSON.parse(localStorage.getItem("trans"));
            }
        }
    },
    actions: {
        SET_TRANS: ({commit}, data) => {
            commit('SET_TRANS', data);
        },
        SET_LANGS: ({commit}, data) => {
            commit('SET_LANGS', data);
        }
    },
    getters: {
        GET_TRANS: state => state.trans,
        GET_LANGS: state => state.langs,
    }
});

export default lang;